
// this file is auto-generated.
// It will be overwritten by the script ../build/set-env-value.js
export const environment = {
  production: true,
  clientVersion: "1.6.47"
};

